import React from 'react'
import Page from '../../components/Page/Page'
import Event from '../../components/University/Event'
import Report from '../../components/University/Report'
import Link from '../../components/University/Link'
import PageTitle from '../../components/University/PageTitle'
import Project from '../../components/University/Project'
import CategoryProvider from '../../components/University/CategoryContext'

const title = '富山大学向け'

const Toyama = () => {
  return (
    <CategoryProvider category="toyama">
      <Page title={title}>
        <PageTitle />
        <Project />
        <Event />
        <Report />
        <Link linkMedical="http://www.med.u-toyama.ac.jp/" />
      </Page>
    </CategoryProvider>
  )
}

export default Toyama
